const listTableFields = [
  {
    label: 'Nomor Kontrak',
    key: 'number',
    isSortable: true,
    isRedirectable: true,
  },
  {
    label: 'Status',
    key: 'status.name',
  },
  {
    label: 'Addendum',
    key: 'version.addendum',
  },
  {
    label: 'Referensi',
    key: 'reference',
  },
  {
    label: 'Nama Vendor',
    key: 'vendor.name',
  },
  {
    label: 'Tanggal Mulai',
    key: 'effective_date',
  },
  {
    label: 'Tanggal Berakhir',
    key: 'expired_date',
  }
]

export default listTableFields
